<template>
  <div>
    <Modal title="存储资源配额" v-model="storageQuotaModal" width="800">
      <Alert show-icon type="error" v-if="storageQuotaError">{{ storageQuotaErrorMsg }}</Alert>
      <Spin fix v-if="storageQuotaLoading">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      </Spin>
      <Spin fix v-else-if="storageQuotaGetError">
        <Alert show-icon type="error">获取数据失败</Alert>
      </Spin>
      <div v-else>
        <Alert show-icon>
          <span>填 -1 表示不限制</span>
        </Alert>
        <Form ref="storageQuotaForm" :model="storageQuotaForm" :rules="storageQuotaRules" :label-width="100">
          <FormItem prop="volumes" label="云硬盘">
            <InputNumber v-model="storageQuotaForm.volumes" style="width: 300px" :min="-1"/>
            <span style="text-align: right; margin-left: 20px" v-if="storageQuota.volumes">
            <span style="color: #19be6b">已用：{{ storageQuota.volumes.in_use }}</span>
          </span>
          </FormItem>
          <FormItem prop="snapshots" label="云硬盘快照">
            <InputNumber v-model="storageQuotaForm.snapshots" style="width: 300px" :min="-1"/>
            <span style="text-align: right; margin-left: 20px" v-if="storageQuota.snapshots">
            <span style="color: #19be6b">已用：{{ storageQuota.snapshots.in_use }}</span>
          </span>
          </FormItem>
          <FormItem prop="gigabytes" label="云硬盘及快照总大小 (GiB) ">
            <InputNumber v-model="storageQuotaForm.gigabytes" style="width: 300px" :min="-1"/>
            <span style="text-align: right; margin-left: 20px" v-if="storageQuota.gigabytes">
            <span style="color: #19be6b">已用：{{ storageQuota.gigabytes.in_use }}</span>
          </span>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" style="margin-right: 8px" @click="storageQuotaSubmit" :loading="storageQuotaSubmitting">修改</Button>
        <Button @click="storageQuotaModal = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getPrivateCloudStorageQuota, updatePrivateCloudStorageQuota } from '@/api/private-cloud/quota-storage'

export default {
  name: 'storage-quota',
  data () {
    return {
      project: {},
      storageQuotaModal: false,
      storageQuotaSubmitting: false,
      storageQuotaLoading: false,
      storageQuotaGetError: false,
      storageQuotaError: false,
      storageQuotaErrorMsg: null,
      storageQuota: {},
      storageQuotaForm: {
        volumes: null,
        snapshots: null,
        gigabytes: null
      },
      storageQuotaRules: {
        volumes: { required: true, message: '卷数量是必填的', type: 'number', trigger: 'blur' },
        snapshots: { required: true, message: '卷快照数量是必填的', type: 'number', trigger: 'blur' },
        gigabytes: { required: true, message: '卷及快照总大小是必填的', type: 'number', trigger: 'blur' }
      }
    }
  },
  methods: {
    getStorageQuota (project) {
      this.project = project
      this.storageQuotaModal = true
      this.storageQuotaLoading = true
      getPrivateCloudStorageQuota(this.project.id).then(res => {
        this.storageQuotaLoading = false
        if (res.data.quota_set) {
          this.storageQuota = res.data.quota_set
          this.storageQuotaForm.volumes = res.data.quota_set.volumes.limit
          this.storageQuotaForm.snapshots = res.data.quota_set.snapshots.limit
          this.storageQuotaForm.gigabytes = res.data.quota_set.gigabytes.limit
          this.storageQuotaGetError = false
        } else {
          this.storageQuotaGetError = true
        }
      }).catch(res => {
        this.storageQuotaLoading = false
        this.storageQuotaGetError = true
        console.error(res.response)
      })
    },
    storageQuotaSubmit () {
      this.$refs.storageQuotaForm.validate((valid) => {
        if (valid) {
          this.storageQuotaSubmitting = true
          updatePrivateCloudStorageQuota(this.storageQuotaForm, this.project.id).then(res => {
            this.storageQuotaSubmitting = false
            this.storageQuotaModal = false
            this.storageQuotaError = false
            this.storageQuotaErrorMsg = null
            this.$Notice.success({title: '操作成功'})
          }).catch(res => {
            this.storageQuotaSubmitting = false
            console.error(res.response)
            this.$Notice.error({title: '操作失败'})
            this.storageQuotaErrorMsg = res.response.data
            this.storageQuotaError = true
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
